import React from 'react';

import './AuInputLabel.scss';

interface Props {
  text: string;
  className?: string;
  dark?: boolean;
  inline?: boolean;
  htmlFor: string;
  style?: React.CSSProperties;
}

const AuInputLabel: React.FC<Props> = ({ text, dark, inline, htmlFor, className = '' }) => (
  <label className={
    `au-label ${className}` +
    `${dark ? ' au-label--dark' : ''}` +
    `${inline ? ' au-label--inline' : ''}`
  }
  htmlFor={htmlFor}
  >
    <strong>{text}</strong>
  </label>
);

export default AuInputLabel;